// src/utils/fantAppRoleOverrides.js
import { FANTAPP_ROLE_OVERRIDES_CONFIGURATION } from '../components/auction/FantAppRoleConfiguration';

function normalizeText(value = '') {
  return String(value)
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

const ROLE_OVERRIDES_BY_NAME = Object.entries(
  FANTAPP_ROLE_OVERRIDES_CONFIGURATION
).reduce((acc, [name, role]) => {
  const key = normalizeText(name);

  if (key) acc[key] = String(role || '').trim().toUpperCase();

  return acc;
}, {});

// Applica i ruoli FantApp (FantAppRoleConfiguration.js) ai giocatori il cui
// nome e' presente nella configurazione, cosi' ovunque si cerchi un
// giocatore nell'app (Giocatori, Scambi liberi...) si vede lo stesso ruolo.
export function applyFantAppRoleOverrides(list) {
  return list.map((player) => {
    const overrideRole = ROLE_OVERRIDES_BY_NAME[normalizeText(player.name || '')];

    return overrideRole ? { ...player, role: overrideRole } : player;
  });
}